import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Radio } from 'antd';

import {
    convertirTextAMomentUTC,
    MASCARA_YYYYMMDD,
    MASCARA_DDMMYYYY
} from '../../commons/gestioDates';

import {
    paginacioPerDefecte,
    ordenarAttribut,
    obtenirEstatPerDefecte,
    realitzarCerca,
    obtenirFiltreDesplegable,
    obtenirFiltreIcona,
    obtenirFiltreDesplegableVisible,
    obtenirFiltreCanviarDesplegableVisible,
    seleccionarPaginacio
} from '../commons/taulaOrdenacioCerca';

import { textQuanNoHiHaDada } from '../../constants';

const columnaCodi = 'codi';
const columnaNomEstacio = 'nomEstacio';
const columnaNomMunicipi = 'nomMunicipi';
const columnaNomComarca = 'nomComarca';
const columnaDataAlta = 'dataAlta';
const columnaObservadors = 'observadors';
const columnaEstat = 'estat';

// Aquesta parametrització de columnes està relacionada amb el mètode obtenirConfiguracioColumnes()
const columnesAmbFiltres = [columnaCodi, columnaNomEstacio, columnaNomMunicipi, columnaNomComarca, columnaDataAlta, columnaEstat];

class EstacioTaula extends Component {

    constructor(props) {
        super(props);
        const { estacions } = props;
        const data = this.construirDadesTaulaEstacions(estacions);
        this.state = obtenirEstatPerDefecte(data, columnesAmbFiltres);
        this.realitzarCercaEstacions = this.realitzarCercaEstacions.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.estacions !== nextProps.estacions) {
            const { estacions } = nextProps;
            const data = this.construirDadesTaulaEstacions(estacions);
            this.setState(() => obtenirEstatPerDefecte(data, columnesAmbFiltres));
        }
    }

    realitzarCercaEstacions(item) {
        const { estacions } = this.props;
        const data = this.construirDadesTaulaEstacions(estacions);
        const { searchText } = this.state.filtres[item];
        realitzarCerca(item, data, searchText, columnesAmbFiltres, this.setState.bind(this));
    }

    obtenirConfiguracioColumnaOrdenadaIFiltrada(nom, item, tipus) {
        return {
            title: nom,
            dataIndex: item,
            key: item,
            sorter: (itemA, itemB) => ordenarAttribut(itemA, itemB, item, tipus),
            filterDropdown: obtenirFiltreDesplegable(item, this.state, this.setState.bind(this), this.realitzarCercaEstacions.bind(this)),
            filterIcon: obtenirFiltreIcona(item, this.state),
            filterDropdownVisible: obtenirFiltreDesplegableVisible(item, this.state),
            onFilterDropdownVisibleChange: (visible) => obtenirFiltreCanviarDesplegableVisible(item, visible, this.setState.bind(this)),
            className: 'estacio-taula-' + item,
            render: text => text || textQuanNoHiHaDada
        };
    }

    obtenirConfiguracioColumnes() {
        return [
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Codi', columnaCodi),
            {
                ...this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Estació', columnaNomEstacio),
                defaultSortOrder: 'ascend',
            },
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Municipi', columnaNomMunicipi),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Comarca', columnaNomComarca),
            {
                title: 'Observadors',
                dataIndex: columnaObservadors,
                key: columnaObservadors,
                render: this.renderLlistatObservadors,
                className: 'estacio-taula-observadors'
            },
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Data d\'alta', columnaDataAlta, 'date'),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Estat', columnaEstat),
        ];
    }

    construirDadesTaulaEstacions(estacions) {
        return Object.keys(estacions).map((idEstacio) => {
            const estacio = estacions[idEstacio];
            const { codi, nomEstacio, nomMunicipi, nomComarca, observadors, dataAlta, estat } = estacio;
            const dataAltaText = dataAlta ? convertirTextAMomentUTC(dataAlta, MASCARA_YYYYMMDD).format(MASCARA_DDMMYYYY) : null;
            return {
                key: idEstacio,
                codi, nomEstacio, nomMunicipi, nomComarca, observadors, dataAlta: dataAltaText, estat
            };
        });
    }

    renderLlistatObservadors(array) {
        if (!array || array.length === 0) return textQuanNoHiHaDada;
        return <div text={array.toString()}>{array.map((item, index) => <div key={index}>{item}</div>)}</div>;
    }

    render() {
        const { estacioIntroduccioSeleccionarEstacio, router } = this.props;
        const { paginacio } = this.state;
        const mostrarSelectorPaginacio = this.state.data.length > 0 ? 'block' : 'none';
        return (
            <div className='estacio-taula'>
                <Table
                    dataSource={this.state.data}
                    columns={this.obtenirConfiguracioColumnes()}
                    pagination={{ pageSize: paginacio, position: 'bottom'}}
                    bordered
                    scroll={{y: 644}}
                    size='middle'
                    onRow={(record) => ({
                        onClick: () => { estacioIntroduccioSeleccionarEstacio(parseInt(record.key, 0), router); }
                    })}
                />
                <Radio.Group
                    className='estacio-taula-selector-paginacio'
                    size='small'
                    onChange={(event) => seleccionarPaginacio(event.target.value, this.setState.bind(this))}
                    style={{ display: mostrarSelectorPaginacio }}
                    value={paginacio}>
                    <Radio.Button value={paginacioPerDefecte}>{paginacioPerDefecte}</Radio.Button>
                    <Radio.Button value={40}>40</Radio.Button>
                    <Radio.Button value={60}>60</Radio.Button>
                    <Radio.Button value={100}>100</Radio.Button>
                </Radio.Group>
            </div>
        );
    }
}

EstacioTaula.propTypes = {
    estacions: PropTypes.object,
    router: PropTypes.object,
    estacioIntroduccioSeleccionarEstacio: PropTypes.func
};

export default EstacioTaula;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioTaula.js